export default "__VITE_ASSET__rLdlTldS__"